/* Chấm công điện thoại — board Mint-Checkin-Phone (390). Màu chỉ var(--…). */
.page { display: flex; flex-direction: column; gap: 12px; min-width: 0; }
.skel { display: flex; flex-direction: column; gap: 12px; }
.card { padding: 16px; border-radius: 18px; background: var(--card); box-shadow: var(--sh); display: flex; flex-direction: column; gap: 8px; min-width: 0; }
.h { font-weight: var(--fw-title); }
.lb { color: var(--lb); }
.sm { font-size: 12px; color: var(--lb); display: flex; align-items: center; gap: 4px; }
.sm[data-tone='ok'], .loc .sm[data-tone='ok'] { color: var(--ok); }
.sm[data-tone='warn'] { color: var(--warn); }
.sm[data-tone='err'] { color: var(--err); }
.hrow { display: flex; justify-content: space-between; align-items: baseline; }
.shift { margin-top: -6px; font-size: 13px; color: var(--lb); display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
.pair { display: flex; gap: 10px; margin-top: 4px; }
.cell { flex: 1 1 0; padding: 12px; border-radius: 14px; background: var(--sub); min-width: 0; }
.cell .lb { font-size: 13px; }
.big { margin-top: 2px; font-size: 26px; font-weight: var(--fw-title); color: var(--lb); }
.big[data-on='true'] { color: var(--ok); }
.chips { display: flex; flex-wrap: wrap; gap: 6px; }
.pill { display: inline-flex; align-items: center; height: 28px; padding: 0 10px; border-radius: 999px; background: var(--ctl); color: var(--tx2); font-size: 13px; font-weight: var(--fw-label); }
.pill[data-tone='ok'] { background: var(--ok-bg); color: var(--ok); }
.pill[data-tone='warn'] { background: var(--warn-bg); color: var(--warn); }
.map { padding: 0; gap: 0; overflow: clip; }
.mapArt { position: relative; height: 140px; background: var(--sub); overflow: clip; }
.mapArt svg { position: absolute; inset: 0; }
.mapArt span { position: absolute; left: 10px; bottom: 8px; padding: 2px 8px; border-radius: 8px; background: var(--card); font-size: 12px; color: var(--tx2); }
.road { stroke: var(--bd); stroke-width: 6; fill: none; }
.geo { fill: var(--pri-bg); stroke: var(--pri); stroke-width: 1.5; stroke-dasharray: 5 4; }
.pin { fill: var(--lb); }
.me { fill: var(--pri); stroke: var(--card); stroke-width: 3; }
.locBody { padding: 12px 16px 14px; display: flex; flex-direction: column; gap: 2px; }
.locA { font-weight: var(--fw-label); }
.row { display: flex; gap: 8px; margin-top: 10px; flex-wrap: wrap; }
.cta { height: 56px; width: 100%; border-radius: 16px; font-size: 17px; }
.alt { height: 48px; width: 100%; border-radius: 14px; }
.allDone { padding: 16px; border-radius: 18px; background: var(--ok-bg); color: var(--ok); text-align: center; font-weight: var(--fw-label); }
.warnBox { padding: 14px 16px; border-radius: 18px; background: var(--warn-bg); }
.alert { display: flex; gap: 10px; padding: 12px 14px; border-radius: 16px; background: var(--err-bg); }
.alert > span { width: 24px; height: 24px; flex-shrink: 0; border-radius: 50%; background: var(--err); color: var(--on-color); display: flex; align-items: center; justify-content: center; font-weight: var(--fw-title); }
.hist { display: flex; align-items: center; gap: 10px; min-height: 52px; border-top: 1px solid var(--line); }
.hd { width: 74px; flex-shrink: 0; }
.hb { flex-grow: 1; min-width: 0; }
.flag { padding: 2px 8px; border-radius: 999px; background: var(--warn-bg); color: var(--warn); font-size: 12px; font-weight: var(--fw-label); }
/* quét / đăng ký */
.cam { position: relative; height: 420px; flex-shrink: 0; border-radius: 24px; background: var(--ctl); overflow: clip; display: flex; align-items: center; justify-content: center; }
.cam[data-enroll] { height: 280px; border-radius: 22px; }
.ringBase { fill: none; stroke: var(--bd); stroke-width: 8; }
.ringBase[data-on='pri'] { stroke: var(--pri); }
.ringBase[data-on='ok'] { stroke: var(--ok-dot); }
.ring { fill: none; stroke: var(--pri); stroke-width: 8; stroke-linecap: round; }
.ring[data-tone='err'] { stroke: var(--err-bd); }
.ring[data-tone='ok'] { stroke: var(--ok-dot); }
.sil { fill: var(--bd); }
.guide { position: absolute; left: 50%; bottom: 16px; transform: translateX(-50%); padding: 6px 14px; border-radius: 999px; background: var(--card); color: var(--tx); font-size: 14px; font-weight: var(--fw-label); white-space: nowrap; box-shadow: var(--sh); }
.guide[data-tone='err'] { color: var(--err); }
.guide[data-tone='ok'] { color: var(--ok); }
.tip { height: 30px; display: inline-flex; align-items: center; padding: 0 10px; border-radius: 999px; background: var(--ctl); color: var(--tx2); font-size: 13px; font-weight: var(--fw-label); }
.loc { display: flex; gap: 10px; align-items: center; padding: 10px 12px; border-radius: 14px; background: var(--card); box-shadow: var(--sh); }
.loc svg[data-tone='ok'] { color: var(--ok); }
.loc svg[data-tone='warn'] { color: var(--warn); }
.loc svg[data-tone='err'] { color: var(--err); }
.loc .locA { font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.field { display: flex; flex-direction: column; gap: 6px; font-size: 13px; font-weight: var(--fw-label); color: var(--tx2); }
.req { color: var(--err); }
.foot { margin-top: auto; display: flex; flex-direction: column; gap: 8px; }
.tipList { margin: 0; padding-left: 20px; display: flex; flex-direction: column; gap: 6px; color: var(--tx2); }
.res { margin: 0; display: flex; flex-direction: column; gap: 8px; font-size: 14px; }
.resRow { display: grid; grid-template-columns: 110px 1fr; gap: 10px; }
.resRow dt { color: var(--lb); }
.resRow dd { margin: 0; font-weight: 500; }
.okBox { padding: 16px; border-radius: 18px; background: var(--ok-bg); color: var(--ok); }
.shots { display: flex; align-items: center; justify-content: center; gap: 8px; }
.shots span { width: 34px; height: 8px; border-radius: 4px; background: var(--bd); }
.shots span[data-on='pri'] { background: var(--pri); }
.shots span[data-on='ok'] { background: var(--ok-dot); }
.shots b { margin-left: 6px; font-size: 14px; font-weight: var(--fw-label); color: var(--tx2); }
.center { text-align: center; font-size: 14px; color: var(--lb); }
.consent { display: flex; gap: 10px; padding: 12px 14px; border-radius: 14px; background: var(--card); box-shadow: var(--sh); cursor: pointer; font-size: 14px; color: var(--tx2); }
.consent input { width: 20px; height: 20px; margin: 2px 0 0; flex-shrink: 0; accent-color: var(--pri); }
.consent b { color: var(--tx); }
.keyIc { width: 52px; height: 52px; border-radius: 16px; background: var(--pri-bg); color: var(--pri); display: flex; align-items: center; justify-content: center; }
.devs { padding: 6px 16px; border-radius: 18px; background: var(--card); box-shadow: var(--sh); }
.dev { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 56px; }
.dev + .dev { border-top: 1px solid var(--line); }
.row button { height: 44px; padding: 0 14px; font-size: 14px; }
.alt { font-size: 15px; }
.hist { gap: 10px; }
